import { CloseOutlined } from "@ant-design/icons";
import { Button, Checkbox, ColorPicker, Form, Input, InputNumber, message, Space } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { useDispatch, useSelector } from "react-redux";
import { userLoaded } from "../../redux/actions";
import { isMobile } from "../../extensions/design";
import { convertFieldsToFloat } from "../../extensions/utils";
import TakePhoto from "../../controls/take-photo/take-photo";
import UploadPhoto from "../../controls/take-photo/upload-photo";
import { LogMonitor } from "@/controls";

const Company = ({ id, onClose }) => {
  const [item, setItem] = useState();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const user = useSelector((s) => s.user);
  const d = useDispatch();
  const [takePhoto, setTakePhoto] = useState(false);
  const [uploadPhoto, setUploadPhoto] = useState(false);
  const [imageVersion, setImageVersion] = useState(Date.now());
  const [pwaTakePhoto, setPwaTakePhoto] = useState(false);
  const [pwaUploadPhoto, setPwaUploadPhoto] = useState(false);
  const [pwaImageVersion, setPwaImageVersion] = useState(Date.now());
  const [bannerTakePhoto, setBannerTakePhoto] = useState(false);
  const [bannerUploadPhoto, setBannerUploadPhoto] = useState(false);
  const [bannerImageVersion, setBannerImageVersion] = useState(Date.now());
  const [backgroundTakePhoto, setBackgroundTakePhoto] = useState(false);
  const [backgroundUploadPhoto, setBackgroundUploadPhoto] = useState(false);
  const [backgroundImageVersion, setBackgroundImageVersion] = useState(Date.now());
  const [mobileBannerTakePhoto, setMobileBannerTakePhoto] = useState(false);
  const [mobileBannerUploadPhoto, setMobileBannerUploadPhoto] = useState(false);
  const [mobileBannerImageVersion, setMobileBannerImageVersion] = useState(Date.now());

  const getData = () => {
    setLoading(true);
    serverFetch(`company/${id}`)
      .then(data => {
        setLoading(false);
        setItem(data);
        form.setFieldsValue(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, [id, form]);

  const onValuesChange = value => {
    setItem({ ...item, ...value });
  };

  const onClosePwaPhoto = (refresh) => {
    setPwaTakePhoto(false);
    refresh && getData();
  };

  const onClosePwaUpload = (refresh) => {
    setPwaUploadPhoto(false);
    refresh && getData();
  };

  const onClosePhoto = (refresh) => {
    setTakePhoto(false);
    refresh && getData();
  }

  const onCloseUpload = (refresh) => {
    setUploadPhoto(false);
    refresh && getData();
  }

  const onDeletePhoto = () => {
    const formData = new FormData();
    serverFetch(`company/photo/${item.id}`, { method: "PUT", body: formData })
      .then(() => {
        const timestamp = Date.now();
        setItem((prev) => ({ ...prev, updatedAt: timestamp }));
        setImageVersion(Date.now());
        onClosePhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onSavePhoto = (file) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    serverFetch(`company/photo/${item.id}`, { method: "PUT", body: formData })
      .then(() => {
        const timestamp = Date.now();
        setItem((prev) => ({ ...prev, updatedAt: timestamp }));
        setImageVersion(Date.now());
        onClosePhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onSavePwaPhoto = (file) => {
    const formData = new FormData();
    formData.append("file", file, file.name);
    serverFetch(`Company/pwaPhoto/${id}`, { method: "PUT", body: formData })
      .then(() => {
        setPwaImageVersion(Date.now());
        onClosePwaPhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onDeletePwaPhoto = () => {
    const formData = new FormData();
    serverFetch(`Company/pwaPhoto/${id}`, { method: "PUT", body: formData })
      .then(() => {
        setPwaImageVersion(Date.now());
        onClosePwaPhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onCloseBannerPhoto = (refresh) => {
    setBannerTakePhoto(false);
    refresh && getData();
  };

  const onCloseBannerUpload = (refresh) => {
    setBannerUploadPhoto(false);
    refresh && getData();
  };

  const onSaveBannerPhoto = (file) => {
    const formData = new FormData();
    formData.append("file", file, file.name);
    serverFetch(`Company/bannerPhoto/${id}`, { method: "PUT", body: formData })
      .then(() => {
        setBannerImageVersion(Date.now());
        onCloseBannerPhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onDeleteBannerPhoto = () => {
    const formData = new FormData();
    serverFetch(`Company/bannerPhoto/${id}`, { method: "PUT", body: formData })
      .then(() => {
        setBannerImageVersion(Date.now());
        onCloseBannerPhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onCloseBackgroundPhoto = (refresh) => {
    setBackgroundTakePhoto(false);
    refresh && getData();
  };

  const onCloseBackgroundUpload = (refresh) => {
    setBackgroundUploadPhoto(false);
    refresh && getData();
  };

  const onSaveBackgroundPhoto = (file) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    serverFetch(`Company/backgroundPhoto/${item.id}`, { method: "PUT", body: formData })
      .then(() => {
        setBackgroundImageVersion(Date.now());
        onCloseBackgroundPhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onDeleteBackgroundPhoto = () => {
    const formData = new FormData();
    serverFetch(`Company/backgroundPhoto/${item.id}`, { method: "PUT", body: formData })
      .then(() => {
        setBackgroundImageVersion(Date.now());
        onCloseBackgroundPhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onCloseMobileBannerPhoto = (refresh) => {
    setMobileBannerTakePhoto(false);
    refresh && getData();
  };

  const onCloseMobileBannerUpload = (refresh) => {
    setMobileBannerUploadPhoto(false);
    refresh && getData();
  };

  const onSaveMobileBannerPhoto = (file) => {
    const formData = new FormData();
    formData.append("file", file, file.name);
    serverFetch(`Company/bannerMobilePhoto/${id}`, { method: "PUT", body: formData })
      .then(() => {
        setMobileBannerImageVersion(Date.now());
        onCloseMobileBannerPhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onDeleteMobileBannerPhoto = () => {
    const formData = new FormData();
    serverFetch(`Company/bannerMobilePhoto/${id}`, { method: "PUT", body: formData })
      .then(() => {
        setMobileBannerImageVersion(Date.now());
        onCloseMobileBannerPhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onSave = () => {
    setLoading(true);
    const bodyData = convertFieldsToFloat(item, ["prcComission", "paymentPrc"]);
    serverFetch("company", { method: "PUT", bodyData })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onSelect = () => {
    setLoading(true);
    serverFetch(`auth/SelectCompany/${id}`, { method: "PUT" })
      .then(() => {
        onClose();
        d(userLoaded({...user, companyId: id}));
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  return<div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className={isMobile ? "sport-modal-content mobile-content" : "sport-modal-content"} style={isMobile ? {} : {width: 800}}>
        <div className={isMobile ? "sport-modal-title-client" : "sport-modal-title"} style={{justifyContent: "space-between"}}>
          <span>Компания</span>
          <CloseOutlined
            className="sport-section-title-close" 
            onClick={() => onClose()} 
            style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}                
          />
        </div>
        <div className={isMobile ? "custom-tabs-mobile-content-client" : "custom-tabs-container"}>
          <Form 
            form={form} 
            labelCol={isMobile ? { span: 24 } : { span: 8 }} 
            wrapperCol={isMobile ? { span: 24 } : { span: 24 }} 
            colon={false} 
            disabled={loading} 
            onValuesChange={onValuesChange}
          >
            <Form.Item label="Активна" name="active" valuePropName="checked"><Checkbox /></Form.Item>
            <Form.Item label="Наименование" name="name" rules={[{ required: true, message: "Введите наименование" }]}><Input maxLength={80} /></Form.Item>
            <Form.Item label="Описание" name="description"><Input.TextArea rows={3} maxLength={500} /></Form.Item>
            <Form.Item label="Телефон" name="phone"><Input maxLength={50} /></Form.Item>
            <Form.Item label="Email" name="email"><Input maxLength={120} /></Form.Item>
            <Form.Item label="Адрес" name="address"><Input maxLength={200} /></Form.Item>
            <Form.Item label="Домен" name="domain"><Input maxLength={120} /></Form.Item>
            <Form.Item label="GMT" name="gmt"><Input type="number" /></Form.Item>
            <Form.Item label="Рабочее время">
              <Space direction={isMobile ? "vertical" : "horizontal"} style={isMobile ? {width: "100%"} : {}}>
                <Form.Item name="hourStart" noStyle style={isMobile ? {width: "100%"} : {}}>
                  <Input type="number" placeholder="Начало" style={isMobile ? {width: "100%"} : {}} />
                </Form.Item>
                <Form.Item name="hourFinish" noStyle style={isMobile ? {width: "100%"} : {}}>
                  <Input type="number" placeholder="Окончание" style={isMobile ? {width: "100%"} : {}} />
                </Form.Item>
              </Space>
            </Form.Item>
            <Form.Item label="Показывать каталог" name="showCatalog" valuePropName="checked"><Checkbox /></Form.Item>
            <Form.Item label="Цвет" name="color" rules={[{ pattern: /^#([0-9a-fA-F]{6})$/, message: "Цвет должен быть в формате #123456" }]} getValueFromEvent={color => color.toHexString()}>
              <ColorPicker format="hex" showText={color => color.toHexString()} />
            </Form.Item>
            <Form.Item label="Рекламный URL" name="adUrl"><Input maxLength={200} /></Form.Item>
            <Form.Item label="Заголовок баннера" name="bannerTitle"><Input maxLength={200} /></Form.Item>
            {isMobile ? (
              <Form.Item label=" ">
                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", marginLeft: 16, gap: 8, width: "100%" }}>
                  <div style={{ flex: 1, width: "50%" }}>
                    <div style={{ fontSize: 14, marginBottom: 8, color: "rgba(0, 0, 0, 0.85)" }}>Фон каталога</div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                      <img
                        src={item?.backgroundImageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.backgroundImageId}.jpg?v=${backgroundImageVersion}` : "/images/sample.png"}
                        alt="background"
                        style={{ width: 80, height: 80, objectFit: "contain", borderRadius: 4, border: "1px solid #f0f0f0" }}
                      />
                      {id && (
                        <Space direction="horizontal">
                          <img src="/images/photo.svg" alt="take-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setBackgroundTakePhoto(true)} />
                          <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setBackgroundUploadPhoto(true)} />
                          {item?.backgroundImageId && (
                            <img src="/images/delete-button.svg" alt="delete-photo" style={{ width: 32, cursor: "pointer" }} onClick={onDeleteBackgroundPhoto} />
                          )}
                        </Space>
                      )}
                    </div>
                    {backgroundTakePhoto && <TakePhoto onClose={onCloseBackgroundPhoto} onSave={onSaveBackgroundPhoto} />}
                    {backgroundUploadPhoto && <UploadPhoto onClose={onCloseBackgroundUpload} onSave={onSaveBackgroundPhoto} />}
                  </div>
                  <div style={{ flex: 1, width: "50%" }}>
                    <div style={{ fontSize: 14, marginBottom: 8, color: "rgba(0, 0, 0, 0.85)" }}>Иконка PWA</div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                      <img
                        src={item?.pwaImageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.pwaImageId}.jpg` : "/images/sample.png"}
                        alt="pwa"
                        style={{ width: 80, height: 80, objectFit: "contain", borderRadius: 4, border: "1px solid #f0f0f0" }}
                      />
                      {id && (
                        <Space direction="horizontal">
                          <img src="/images/photo.svg" alt="take-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setPwaTakePhoto(true)} />
                          <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setPwaUploadPhoto(true)} />
                          {item?.pwaImageId && (
                            <img src="/images/delete-button.svg" alt="delete-photo" style={{ width: 32, cursor: "pointer" }} onClick={onDeletePwaPhoto} />
                          )}
                        </Space>
                      )}
                    </div>
                    {pwaTakePhoto && <TakePhoto onClose={onClosePwaPhoto} onSave={onSavePwaPhoto} />}
                    {pwaUploadPhoto && <UploadPhoto onClose={onClosePwaUpload} onSave={onSavePwaPhoto} />}
                  </div>
                  <div style={{ flex: 1, width: "50%" }}>
                    <div style={{ fontSize: 14, marginBottom: 8, color: "rgba(0, 0, 0, 0.85)" }}>Баннер</div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                      <img
                        src={item?.bannerImageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.bannerImageId}.jpg?v=${bannerImageVersion}` : "/images/sample.png"}
                        alt="banner"
                        style={{ width: 80, height: 80, objectFit: "contain", borderRadius: 4, border: "1px solid #f0f0f0" }}
                      />
                      {id && (
                        <Space direction="horizontal">
                          <img src="/images/photo.svg" alt="take-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setBannerTakePhoto(true)} />
                          <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setBannerUploadPhoto(true)} />
                          {item?.bannerImageId && (
                            <img src="/images/delete-button.svg" alt="delete-photo" style={{ width: 32, cursor: "pointer" }} onClick={onDeleteBannerPhoto} />
                          )}
                        </Space>
                      )}
                    </div>
                    {bannerTakePhoto && <TakePhoto onClose={onCloseBannerPhoto} onSave={onSaveBannerPhoto} />}
                    {bannerUploadPhoto && <UploadPhoto onClose={onCloseBannerUpload} onSave={onSaveBannerPhoto} />}
                  </div>
                  <div style={{ flex: 1, width: "50%" }}>
                    <div style={{ fontSize: 14, marginBottom: 8, color: "rgba(0, 0, 0, 0.85)" }}>Логотип</div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                      <img
                        src={item?.pictureId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.pictureId}.jpg` : "/images/logo.png"}
                        alt="logo"
                        style={{ width: 80, height: 80, objectFit: "contain", borderRadius: 4, border: "1px solid #f0f0f0" }}
                      />
                      {id && (
                        <Space direction="horizontal">
                          <img src="/images/photo.svg" alt="take-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setTakePhoto(true)} />
                          <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setUploadPhoto(true)} />
                          {item?.pictureId && (
                            <img src="/images/delete-button.svg" alt="delete-photo" style={{ width: 32, cursor: "pointer" }} onClick={onDeletePhoto} />
                          )}
                        </Space>
                      )}
                    </div>
                    {takePhoto && <TakePhoto onClose={onClosePhoto} onSave={onSavePhoto} />}
                    {uploadPhoto && <UploadPhoto onClose={onCloseUpload} onSave={onSavePhoto} />}
                  </div>
                  <div style={{ flex: 1, width: "100%", gridColumn: "span 2" }}>
                    <div style={{ fontSize: 14, marginBottom: 8, color: "rgba(0, 0, 0, 0.85)" }}>Моб. баннер</div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 8 }}>
                      <img
                        src={item?.mobileBannerImageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.mobileBannerImageId}.jpg?v=${mobileBannerImageVersion}` : "/images/sample.png"}
                        alt="mobile-banner"
                        style={{ width: 160, height: 80, objectFit: "contain", borderRadius: 4, border: "1px solid #f0f0f0" }}
                      />
                      {id && (
                        <Space direction="horizontal">
                          <img src="/images/photo.svg" alt="take-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setMobileBannerTakePhoto(true)} />
                          <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setMobileBannerUploadPhoto(true)} />
                          {item?.mobileBannerImageId && (
                            <img src="/images/delete-button.svg" alt="delete-photo" style={{ width: 32, cursor: "pointer" }} onClick={onDeleteMobileBannerPhoto} />
                          )}
                        </Space>
                      )}
                    </div>
                    {mobileBannerTakePhoto && <TakePhoto onClose={onCloseMobileBannerPhoto} onSave={onSaveMobileBannerPhoto} />}
                    {mobileBannerUploadPhoto && <UploadPhoto onClose={onCloseMobileBannerUpload} onSave={onSaveMobileBannerPhoto} />}
                  </div>
                </div>
              </Form.Item>
            ) : (
              <>
                <Form.Item label="Фон каталога">
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexDirection: isMobile ? "column" : "row" }}>
                    <img
                      src={item?.backgroundImageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.backgroundImageId}.jpg?v=${backgroundImageVersion}` : "/images/sample.png"}
                      alt="bachground"
                      style={{ width: 80, height: 80, objectFit: "contain", borderRadius: 4, border: "1px solid #f0f0f0" }}
                    />
                    {item?.id !== 0 && (
                      <Space direction="horizontal">
                        <img src="/images/photo.svg" alt="take-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setBackgroundTakePhoto(true)} />
                        <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setBackgroundUploadPhoto(true)} />
                        {item?.backgroundImageId && (
                          <img src="/images/delete-button.svg" alt="delete-photo" style={{ width: 32, cursor: "pointer" }} onClick={onDeleteBackgroundPhoto} />
                        )}
                      </Space>
                    )}
                  </div>
                  {backgroundTakePhoto && <TakePhoto onClose={onCloseBackgroundPhoto} onSave={onSaveBackgroundPhoto} />}
                  {backgroundUploadPhoto && <UploadPhoto onClose={onCloseBackgroundUpload} onSave={onSaveBackgroundPhoto} />}
                </Form.Item>
                <Form.Item label="Картинка баннера">
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexDirection: isMobile ? "column" : "row" }}>
                    <img
                      src={item?.bannerImageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.bannerImageId}.jpg?v=${bannerImageVersion}` : "/images/sample.png"}
                      alt="banner"
                      style={{ width: 80, height: 80, objectFit: "contain", borderRadius: 4, border: "1px solid #f0f0f0" }}
                    />
                    {id && (
                      <Space direction="horizontal">
                        <img src="/images/photo.svg" alt="take-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setBannerTakePhoto(true)} />
                        <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setBannerUploadPhoto(true)} />
                        {item?.bannerImageId && (
                          <img src="/images/delete-button.svg" alt="delete-photo" style={{ width: 32, cursor: "pointer" }} onClick={onDeleteBannerPhoto} />
                        )}
                      </Space>
                    )}
                  </div>
                  {bannerTakePhoto && <TakePhoto onClose={onCloseBannerPhoto} onSave={onSaveBannerPhoto} />}
                  {bannerUploadPhoto && <UploadPhoto onClose={onCloseBannerUpload} onSave={onSaveBannerPhoto} />}
                </Form.Item>
                <Form.Item label="Моб. баннер">
                  <div style={{ display: "flex", alignItems: "flex-start", gap: 8, flexDirection: isMobile ? "column" : "row" }}>
                    <img
                      src={item?.mobileBannerImageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.mobileBannerImageId}.jpg?v=${mobileBannerImageVersion}` : "/images/sample.png"}
                      alt="mobile-banner"
                      style={{ width: 160, height: 80, objectFit: "contain", borderRadius: 4, border: "1px solid #f0f0f0" }}
                    />
                    {id && (
                      <Space direction="horizontal">
                        <img src="/images/photo.svg" alt="take-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setMobileBannerTakePhoto(true)} />
                        <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setMobileBannerUploadPhoto(true)} />
                        {item?.mobileBannerImageId && (
                          <img src="/images/delete-button.svg" alt="delete-photo" style={{ width: 32, cursor: "pointer" }} onClick={onDeleteMobileBannerPhoto} />
                        )}
                      </Space>
                    )}
                  </div>
                  {mobileBannerTakePhoto && <TakePhoto onClose={onCloseMobileBannerPhoto} onSave={onSaveMobileBannerPhoto} />}
                  {mobileBannerUploadPhoto && <UploadPhoto onClose={onCloseMobileBannerUpload} onSave={onSaveMobileBannerPhoto} />}
                </Form.Item>
                <Form.Item label="Иконка PWA">
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexDirection: isMobile ? "column" : "row" }}>
                    <img
                      src={item?.pwaImageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.pwaImageId}.jpg?v=${pwaImageVersion}` : "/images/sample.png"}
                      alt="pwa"
                      style={{ width: 80, height: 80, objectFit: "contain", borderRadius: 4, border: "1px solid #f0f0f0" }}
                    />
                    {id && (
                      <Space direction="horizontal">
                        <img src="/images/photo.svg" alt="take-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setPwaTakePhoto(true)} />
                        <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setPwaUploadPhoto(true)} />
                        {item?.pwaImageId && (
                          <img src="/images/delete-button.svg" alt="delete-photo" style={{ width: 32, cursor: "pointer" }} onClick={onDeletePwaPhoto} />
                        )}
                      </Space>
                    )}
                  </div>
                  {pwaTakePhoto && <TakePhoto onClose={onClosePwaPhoto} onSave={onSavePwaPhoto} />}
                  {pwaUploadPhoto && <UploadPhoto onClose={onClosePwaUpload} onSave={onSavePwaPhoto} />}
                </Form.Item>
                <Form.Item label="Логотип">
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexDirection: isMobile ? "column" : "row" }}>
                    <img
                      src={item?.pictureId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.pictureId}.jpg` : "/images/logo.svg"}
                      alt="logo"
                      style={{ width: 80, height: 80, objectFit: "contain", borderRadius: 4, border: "1px solid #f0f0f0" }}
                    />
                    {id && (
                      <Space direction="horizontal">
                        <img src="/images/photo.svg" alt="take-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setTakePhoto(true)} />
                        <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setUploadPhoto(true)} />
                        {!!item?.pictureId && (
                          <img src="/images/delete-button.svg" alt="delete-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => onDeletePhoto()} />
                        )}
                      </Space>
                    )}
                  </div>
                  {takePhoto && <TakePhoto onClose={onClosePhoto} onSave={onSavePhoto} />}
                  {uploadPhoto && <UploadPhoto onClose={onCloseUpload} onSave={onSavePhoto} />}
                </Form.Item>
              </>
            )}
            <Form.Item label="Ссылка TG" name="tgUrl"><Input maxLength={200} /></Form.Item>
            {/*
            <Form.Item label="Ссылка условий оплаты" name="paymentConditionUrl"><Input maxLength={200} /></Form.Item>
            <Form.Item label="Ссылка условий автоопл." name="autopayConditionUrl"><Input maxLength={200} /></Form.Item>
            */}
            <Form.Item label="Комиссия, %">
              <Space direction={isMobile ? "vertical" : "horizontal"} style={isMobile ? {width: "100%"} : {}}>
                <Form.Item name="prcComission" noStyle style={isMobile ? {width: "100%"} : {}}>
                  <Input type="number" style={isMobile ? {width: "100%"} : {}} />
                </Form.Item>
                <Form.Item name="comissionIncluded" valuePropName="checked" noStyle style={isMobile ? {width: "100%"} : {}}>
                  <Checkbox style={isMobile ? {marginLeft: 0} : { marginLeft: 8 }}>Включена</Checkbox>
                </Form.Item>
              </Space>
            </Form.Item>
            <Form.Item label="Комиссия по договору, %" name="paymentPrc">
              <InputNumber precision={4} style={{ width: isMobile ? "100%" : 160 }} />
            </Form.Item>
            {!isMobile && (
              <Form.Item label=" ">
                <Space>
                  <Button onClick={onSave}>Сохранить</Button>
                  <Button onClick={onSelect}>Выбрать</Button>
                  <LogMonitor vid={9} id={id}/>
                  <Button onClick={() => onClose(false)}>Закрыть</Button>
                </Space>
              </Form.Item>
            )}
            {isMobile && (
              <Form.Item>
                <Space style={{width: "100%", justifyContent: "space-between"}}>
                  <Button onClick={onSave}>Сохранить</Button>
                  <Button onClick={onSelect}>Выбрать</Button>
                  <LogMonitor vid={9} id={id}/>
                </Space>
              </Form.Item>
            )}
          </Form>
        </div>
      </div>
    </div>
  </div>
}

export default Company;
